module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"cancelled":"CANCELADO"},"en":{"cancelled":"CANCELLED"}}')
  delete Component.options._Ctor
}
